import { redirect } from 'react-router'
import { VenueOnboardingShell } from '../components/venue-onboarding-shell'
import { Button } from '../components/ui'
import { getOperatorContext } from '../../server/lib/loader-context'
import { HStack, VStack, styled } from '../styled-system/jsx'
import type { Route } from './+types/venues.start'

export function meta() {
    return [{ title: 'List your venue - ENTX' }]
}

export async function loader({ request }: Route.LoaderArgs) {
    const operator = await getOperatorContext(request)
    if (operator) {
        throw redirect(
            operator.user.emailVerified
                ? '/onboarding'
                : `/verify-email?intent=venue&email=${encodeURIComponent(operator.user.email)}`,
        )
    }

    return {}
}

export default function VenueStart() {
    return (
        <VenueOnboardingShell
            title="List your venue"
            description="Create your ENTX account to prepare your venue profile. You will review the subscription before submitting your venue."
        >
            <styled.section borderWidth="1px" borderColor="border.subtle" borderRadius="lg" p={{ base: '5', md: '7' }}>
                <VStack gap="6" alignItems="stretch">
                    <VStack gap="2" alignItems="stretch">
                        <styled.h2 fontSize="xl" fontWeight="semibold">
                            Start your venue listing
                        </styled.h2>
                        <styled.p color="fg.muted">
                            New operators create an account first. Existing ENTX customers can use their current login.
                        </styled.p>
                    </VStack>
                    <HStack gap="3" flexWrap="wrap">
                        <Button asChild>
                            <styled.a href="/signup?intent=venue">Create account</styled.a>
                        </Button>
                        <Button variant="outline" asChild>
                            <styled.a href="/login?intent=venue">Sign in</styled.a>
                        </Button>
                    </HStack>
                </VStack>
            </styled.section>
        </VenueOnboardingShell>
    )
}
